<template>
  <div>
    <div class="kt-login__head"></div>
    <div class="kt-login__body">
      <div class="kt-login__form">
        <div class="kt-login__title">
          <h3>{{ $t("AUTH.RESET_PASSWORD.TITLE") }}</h3>
        </div>
        <PasswordRecovery
          :key="resetReference"
          stage="redeem"
          :reference="resetReference"
          @cancel="goFrontPage"
        />
      </div>
    </div>
  </div>
</template>

<style lang="scss">
@import "@/assets/sass/pages/error/error-3.scss";
</style>

<script>
import PasswordRecovery from "@/views/partials/PasswordRecovery.vue";

export default {
  name: "ForgotPass",
  components: { PasswordRecovery },
  computed: {
    resetReference() {
      return typeof this.$route.query.ref === "string"
        ? this.$route.query.ref
        : "";
    },
  },
  methods: {
    goFrontPage() {
      this.$router.push("/login");
    },
  },
};
</script>
